<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Kyc Group"
            bc1="App"
            bc2="Update Kyc Group"
            bc3="Update"
            path="Kyc Group"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-2 col-form-label">
                            <label>Group Name</label>
                          </div>
                          <div class="col-sm-8">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Enter Group Name" :class="
                                  errorBag.has('name') ? 'is-invalid' : ''" v-model="name" name="name" v-validate="'required'" />
                            </div>
                            <small
                              v-show="errorBag.has('name')"
                              class=""
                            >{{ "*" + errorBag.first("name") }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-for="(kycField,kycFieldIndex) in kycFields" :key="kycFieldIndex">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3  offset-sm-2">
                            <div class="input-group">
                              <input class="form-control" placeholder="Enter Field Label Name" v-model="kycFields[kycFieldIndex]['name']" />
                            </div>
                          </div>
                          <div class="col-sm-3 ">
                            <div class="input-group">
                              <select class="form-control" v-model="kycFields[kycFieldIndex]['fieldId']">
                                <option value="">Select Type</option>
                                <option :value="item.id" v-for="(item) in inputTypeOption">
                                  {{item.type}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-3  ">
                            <div v-if="typeof(kycField.status) != 'undefined'" class="custom-control custom-switch " style="margin-top: 2%;">
                              <input :id="'checkBox_'+kycField.id+'_'+kycFieldIndex" type="checkbox"   :true-value="1"
                                     :false-value="0"
                                     class="custom-control-input" v-model="kycFields[kycFieldIndex]['status']" />
                              <label class="custom-control-label"
                                     :for="'checkBox_'+kycField.id+'_'+kycFieldIndex">
                              </label>
                            </div>
                            <button v-else type="button" class="btn btn-danger btn-sm " style="margin-top: 2%;" @click="removeField(kycFieldIndex)">Remove</button>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-form-label offset-sm-2 ">
                        <button type="button" class="btn btn-success btn-warning btn-sm" @click="addMoreFields">{{!kycFields.length?'Add Group Field' : 'Add More'}}</button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-10  d-flex justify-content-end">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'kyc-group' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
export default {
  components: {
    CommandIcon
  },
  mounted() {

    this.getInputTypes()
    let kycGroupUpdate = this.$store.getters.getByKey("kycGroupUpdate");


    this.id = kycGroupUpdate.row.id;
    this.name  = kycGroupUpdate.row.name;
    let tempFields = []
    kycGroupUpdate.row.fields.map(item => {
      tempFields.push({
        "fieldId": item.field_id,
        "name": item.name,
        "id": item.id,
        "status": item.status,
      })
    })

    this.kycFields = tempFields




  },
  data() {
    return {
      id:'',
      name: "",
      type: "",
      loading: false,
      size: "10px",
      kycFields: [],
      inputTypeOption: [],
    };
  },
  methods: {
    addMoreFields(){
      this.kycFields.push({
        "fieldId": '',
        "name": ''
      })
    },
    removeField(index) {
      this.kycFields.splice(index, 1);
    },
    getInputTypes(){
      this.makeRequest("post", "v1/get-input-types", {status:1,flag:'active'}, {}, false,true,[205]).then(
        callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              let data = []
              data = callResponse.response.data.data;
              if(data.data){
                this.inputTypeOption = data.data
              }


            }
          }
        }
      );
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            kycGroupId: this.id,
            id: this.id,
            name : this.name,
            fields : JSON.stringify(this.kycFields),
          }



          this.makeRequest("post", "v1/update-kyc-group", data).then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.loading = false;
                if (callResponse.response.data.data) {
                  let responseData = callResponse.response.data.data;
                  let storeData = this.$store.getters.getByKey("kyc-group");
                  if (storeData != null) {
                    if (typeof storeData.firstPageData != "undefined") {
                      if (
                        typeof storeData.firstPageData.data[this.index] !=
                        "undefined"
                      ) {
                        if (
                          storeData.firstPageData.data[this.index].id ==
                          this.id
                        ) {
                          storeData.firstPageData.data[
                            this.index
                            ] = responseData;
                          delete storeData.otherPageData;
                        }
                      }
                    }
                    if (typeof storeData.otherPageData != "undefined") {
                      if (
                        typeof storeData.otherPageData.data[this.index] !=
                        "undefined"
                      ) {
                        if (
                          storeData.otherPageData.data[this.index].id ==
                          this.id
                        ) {
                          storeData.otherPageData.data[
                            this.index
                            ] = responseData;
                        }
                      }
                    }
                    storeData.key = "kyc-group";
                    this.$store.dispatch("set", storeData);
                  }
                  this.$router.push({
                    name: "kyc-group",
                    // params: { update: true }
                  });
                }
              } else {
                this.loading = false;
              }
            }
            this.loading = false;
          });
        }
      });
    }
  },
  watch:{

  }
};
</script>

